import React, { useEffect, useState } from "react";
import useFetchData from "../../../common/api/useFetchData";
import useSearchState from "../../useSearchState";

interface AdditionalSearchLinkProps {
	endpoint: string;
	linkTo: string;
	param: string;
}

export function AdditionalSearchLink({
	endpoint,
	linkTo,
	param,
}: AdditionalSearchLinkProps) {
	const { currentInput, resultExists } = useSearchState();
	const [link, setLink] = useState({
		displayLink: false,
		link: null,
	});

	const params = {
		[param]: currentInput.get(param),
	};

	const { data } = useFetchData({ endpoint, params });

	useEffect(() => {
		if (data) {
			setLink((link) => ({
				...link,
				displayLink: data.displayLink,
				link: data.link,
			}));
		}
	}, [data]);

	if (link.displayLink) {
		if (resultExists) {
			return (
				<div className="additional-results">
					<p>
						There are additional{" "}
						<a href={link.link}>search results</a> in the {linkTo}{" "}
						with the registration defined.
					</p>
				</div>
			);
		} else {
			return (
				<>
					<h5>No results</h5>
					<p>
						No results matching your query. There are search results
						in the {linkTo} with the registration defined.
					</p>
					<a href={link.link} className="btn btn--primary">
						See {linkTo} Results
					</a>
				</>
			);
		}
	} else {
		if (!resultExists) {
			return (
				<>
					<h5>No results</h5>
					<p>
						There are no results at the moment. <br />
						Start searching by filter.
					</p>
				</>
			);
		} else {
			return null;
		}
	}
}
